import { useState } from 'react'

export function useToggle (state = false) {
  const [isOpen, setIsOpen] = useState(state)
  const toggleIsOpen = () => { setIsOpen(isOpen => !isOpen) }

  return [isOpen, toggleIsOpen]
}
